import { observer } from 'mobx-react-lite'
import { EnumHelperText, HelperText } from 'shared/ui'
import { TagsSelect } from 'entities/Tags'
import { AgentActionTagStore } from '../store/agentActionTagStore'
import { type IAgentActionContentProps } from '../types/types'

import styles from './styles.module.scss'

export type IMakeActionTagsConfig = {
  canCreate: boolean
  placeholder: string
}

export const makeActionTags = ({ canCreate, placeholder }: IMakeActionTagsConfig) => {
  return observer(({ control, error, onErrorReset }: IAgentActionContentProps) => {
    if (!(control instanceof AgentActionTagStore)) return null
    return (
      <div className={styles.tagContainer}>
        <TagsSelect
          control={control.store}
          canCreate={canCreate}
          placeholder={placeholder}
          error={{ message: error }}
          onChange={onErrorReset}
        />
        {!!error && (
          <HelperText icon={'alertTriangleSmall'} variant={EnumHelperText.Error} text={error} />
        )}
      </div>
    )
  })
}
